import React, { useEffect } from 'react'
import styled from 'styled-components'
import CalendarClock from '../../../../../components/Images/CalendarClock'
import CrossIcon from '../../../../../components/Images/CrossIcon'
import { Popup } from '../../../../../components/Popup'
import '../chapterAddEdit.css'

const SchedulePublishDiv = styled.div`
  display: flex;
  flex-direction: column;
`
const SchedulePublishtTitleDiv = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin-bottom: 10px;
`
const SchedulePublishtLabel = styled.label`
  font-size: 20px;
  font-weight: bold;
  flex: 1;
`
const StyledCrossIcon = styled(CrossIcon)`
  // align-self: center;
  fill: var(--storm-op-64);
  height: 12px;
  width: 12px;
  cursor: pointer;
`
const ChapterTitleDiv = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`
const NovelImageDiv = styled.div`
  margin-right: 8px;
  width: 40px;
  height: 60px;
  border-radius: 4px;
  box-shadow: rgb(73 83 89 / 16%) 0px 4px 8px 0px;
`
const ChapterTextDiv = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
`
const ChapterText = styled.label`
  font-size: 16px;
  color: var(--storm-text-storm-500);
  margin-top: 0px;
  letter-spacing: normal;
  font-weight: normal;
  margin-bottom: 8px;
`
const ChapterWordCount = styled.label`
  font-size: 14px;
  font-weight: normal;
  color: var(--strom-text-strom-300);
`
const PublishTimeDiv = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 140px;
`
const TimerDiv = styled.div`
  display: flex;
  margin: 8px 0px;
  align-items: center;
`
const TimerText = styled.label`
  font-size: 14px;
  color: var(--storm-text-storm-500);
  flex: 1;
`
const PublishText = styled.label`
  font-size: 14px;
  color: var(--storm-text-storm-500);
  flex: 1;
`
const PublishDateDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`
const PublishDateLabel = styled.label`
  font-size: 16px;
  color: var(--strom-text-strom-500);
`
const ChangeDateLabel = styled.label`
  font-size: 12px;
  color: var(--azure-500);
  cursor: pointer;
`
const PublishTimerDiv = styled.div`
  display: flex;
  margin: 8px 0px;
`
const DefaultPublishTimeDiv = styled.div`
  border-radius: 32px;
  border: solid 1px var(--corn-op-24);
  background-color: var(--corn-op-8);
  display: flex;
  justify-content: center;
  padding: 6px;
`
const PublishAndCancelDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
const PublishButton = styled.button`
  padding: 10px 14px;
  border-radius: 4px;
  background-color: var(--azure-500);
  border: none;
  width: 100px;
  color: rgba(255, 255, 255, 0.88);
  margin: 8px 0px;
  cursor: pointer;
`
const CancelButton = styled.button`
  padding: 10px 14px;
  border-radius: 4px;
  border: none;
  width: 100px;
  color: var(--storm-text-storm-300);
  margin: 8px 0px;
  background: #ffffff;
  font-weight: bold;
  cursor: pointer;
`
const CalendarDateDiv = styled.div`
  display: flex;
`

function SchedulePublishPopup({
  schedulePublishPopup,
  setSchedulePublishPopup,
  title,
  wordCount,
  timer,
  onPublishButtonClick,
  userCalendarDate,
  onChangeTimeClick,
  toggleTimer,
  schedulerPopup
}) {
  const isMobile = window.screen.width < 600

  return (
    <Popup
      show={schedulerPopup}
      close={() => setSchedulePublishPopup(false)}
      className={isMobile ? 'schedule-calendar-mobile' : 'schedule-calendar'}
    >
      <SchedulePublishDiv>
        <SchedulePublishtTitleDiv>
          <SchedulePublishtLabel>Publish Planner</SchedulePublishtLabel>
          <StyledCrossIcon onClick={() => setSchedulePublishPopup(false)} />
        </SchedulePublishtTitleDiv>
        <ChapterTitleDiv>
          <NovelImageDiv>
            <img src={window.localStorage.getItem('NovelImage')} alt="Novel" />
          </NovelImageDiv>
          <ChapterTextDiv>
            <ChapterText>{title}</ChapterText>
            <ChapterWordCount>Word Count {wordCount}</ChapterWordCount>
          </ChapterTextDiv>
        </ChapterTitleDiv>
        <PublishTimeDiv>
          <TimerDiv>
            <TimerText>Timer</TimerText>
            <div>
              <label className="switch">
                <input
                  type="checkbox"
                  defaultChecked
                  onClick={() => toggleTimer(!timer)}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </TimerDiv>
          {timer && (
            <PublishTimerDiv>
              <PublishText>Publish Timer</PublishText>

              <PublishDateDiv>
                <CalendarDateDiv>
                  <PublishDateLabel>{userCalendarDate}</PublishDateLabel>
                  <CalendarClock />
                </CalendarDateDiv>
                <ChangeDateLabel onClick={onChangeTimeClick}>
                  Plan
                </ChangeDateLabel>
              </PublishDateDiv>
            </PublishTimerDiv>
          )}
          {timer && (
            <DefaultPublishTimeDiv>
              Default Publish Time is 05:00 AM (IST)
            </DefaultPublishTimeDiv>
          )}
        </PublishTimeDiv>

        <PublishAndCancelDiv>
          <PublishButton onClick={onPublishButtonClick}>Publish</PublishButton>
          <CancelButton onClick={() => setSchedulePublishPopup(false)}>
            Cancel
          </CancelButton>
        </PublishAndCancelDiv>
      </SchedulePublishDiv>
    </Popup>
  )
}

export default SchedulePublishPopup